const DashboardCards = ({
    cards,
    cardClassName = "",
    showValue = true,
    loading = false,
}) => {
    if (loading) {
        return (
            <div className="dashboard-grid">
                {[...Array(5)].map((_, index) => (
                    <div
                        className={`dashboard-card ${cardClassName}`}
                        key={index}
                    >
                        <div
                            className="card-icon animate-pulse bg-gray-300"
                            style={{ backgroundColor: "#E5E7EB" }}
                        />

                        <div className="card-content flex-1">
                            <div className="h-2 w-24 bg-gray-200 rounded animate-pulse mb-2"></div>

                            {showValue && (
                                <div className="h-3 w-16 bg-gray-300 rounded animate-pulse"></div>
                            )}

                            {/* <div className="h-2 w-32 bg-gray-200 rounded animate-pulse"></div> */}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="dashboard-grid">
            {cards.map((card, index) => {
                const Icon = card.icon;

                return (
                    <div
                        className={`dashboard-card ${cardClassName}`}
                        key={card.id ?? index}
                    >
                        <div
                            className="card-icon"
                            style={{ backgroundColor: card.color }}
                        >
                            {Icon && <Icon size={24} color="#fff" />}
                        </div>

                        <div className="card-content">
                            <span>{card.title}</span>

                            {showValue && (
                                <h2>{card.value}</h2>
                            )}

                            {card.subtitle && (
                                <p className="card-subtitle">
                                    {card.subtitle}
                                </p>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default DashboardCards;